import { create } from "zustand";
import axios from "../helper/axios";
const useExportTemplateStore = create((set) => ({
  currentExportTemplateArray: [],
  templateData: [],

  allExportTemplates: [],

  setCurrentExportTemplateArray: (value) =>
    set({ currentExportTemplateArray: value }),

  getTemplateData : async () => {
    try {
    
      const response = await axios.get(
        `/getTemplateVariables`
      );
      console.log("Template Variables:", response.data.data);
      set({ templateData: response.data.data });
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },

  getAllExportTemplate: async () => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.get(
        `/getAllExportTrackerTemlplates/${userDetails.qhoid}/${userDetails.qhuid}`
      );
      console.log(response.data.data);
      set({ allExportTemplates: response.data.data });
      return response.data.data;
    } catch (err) {
      console.log(err);
    }
  },

  createExportTemplate: async (body) => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.post(
        `/updateExportTrackerTemplates/${userDetails.qhoid}/${userDetails.qhuid}`,
        body
      );
      const get = useExportTemplateStore.getState();
      await get.getAllExportTemplate();
      return response.data.ids;
    } catch (err) {
      console.log(err);
    }
  },

  updateExportTemplate: async (body) => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.post(
        `/updateExportTrackerTemplates/${userDetails.qhoid}/${userDetails.qhuid}`,
        body
      );
      console.log(response.data.data);
      const get = useExportTemplateStore.getState();
      await get.getAllExportTemplate();
    } catch (err) {
      console.log(err);
    }
  },

  deleteExportTemplate: async (id) => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.post(
        `/updateExportTrackerTemplates/${userDetails.qhoid}/${userDetails.qhuid}`,
        {
          UpdateType: "TEMPLATE_DELETE",
          TemplateList: [
            {
              TemplateId: id,
            },
          ],
        }
      );
      //console.log(response.data.data);
      const get = useExportTemplateStore.getState();
      await get.getAllExportTemplate();
    } catch (err) {
      console.log(err);
    }
  },
  downloadTemplateExcel: async (templateData) => {
    try {
      const response = await axios.post(
        `/downloadTemplate`,
        { Headers: templateData },
        { responseType: "blob" }
      );
      const contentType = (response.headers && response.headers["content-type"]) || "application/octet-stream";
      const blob = new Blob([response.data], { type: contentType });

      // Determine filename from Content-Disposition if available
      let filename = `template_${new Date().toISOString().slice(0, 10)}.csv`;
      const disposition = response.headers && response.headers["content-disposition"];
      if (disposition) {
        const filenameMatch = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/);
        if (filenameMatch) {
          filename = decodeURIComponent(filenameMatch[1] || filenameMatch[2]);
        }
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  },

 

}));

export default useExportTemplateStore;
